<template>
    <div>
        <vapp-header btnBack btnItemCreate></vapp-header>
        <div class="container-guest p-5 d-flex flex-column align-items-center">

            <form class="w-100 form-fnc" autocomplete="off">
                <label>Item Name*</label>
                <div class="input-group" style="margin-bottom: 25px;">
                    <input type="text" class="form-control padding-override" placeholder="e.g. Samsung Galaxy Note 9" v-model="item_name"
                           v-bind:class="{ 'is-invalid': attemptSubmit && missingItemName }">
                    <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'name'">{{ error.text }}</div>
                </div>

                <label>Code / SKU</label>
                <div class="input-group" style="margin-bottom: 25px;">
                    <input type="text" class="form-control padding-override" placeholder="e.g. SKU66953" v-model="sku">
                </div>

                <div class="switch">
                    <md-switch v-model="for_sale">For Sale</md-switch>
                </div>
                <div v-if="for_sale">
                    <label>Sale Unit Price*</label>
                    <div class="input-group">
                        <input type="text" class="form-control padding-override" placeholder="e.g. 200" required v-model="sale_unit_price"
                               v-bind:class="{ 'is-invalid': attemptSubmit && missingSaleUnitPrice }">
                        <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'sale_unit_price'">{{ error.text }}</div>
                    </div>

                    <label>Tax Code</label>
                    <div class="input-group">
                        <select class="custom-select mr-sm-2 padding-override" v-model="sale_tax_code">
                            <option disabled>Select Tax Code</option>
                            <option v-for="(item, index) in tax_codes" :value="item.id" :key="index">{{ item.code }}</option>
                        </select>
                    </div>

                    <label>Description</label>
                    <div class="input-group">
                        <textarea class="form-control notes padding-override" id="" cols="30" rows="5" v-model="sale_description">Additional notes visible to your customer</textarea>
                    </div>

                    <label>Income Category*</label>
                    <div class="input-group">
                        <select class="custom-select mr-sm-2 padding-override" v-model="income_category" v-bind:class="{ 'is-invalid': attemptSubmit && missingIncomeCategory }">
                            <option disabled>Select Income Category</option>
                            <option v-for="(item, index) in income_categories_filtered" :value="item.id" :key="index">{{ item.name }}</option>
                        </select>
                        <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'income_category'">{{ error.text }}</div>
                    </div>
                </div>

                <div class="switch">
                    <md-switch v-model="for_purchase">For Purchase</md-switch>
                </div>
                <div v-if="for_purchase">
                    <label>Purchase Unit Price*</label>
                    <div class="input-group">
                        <input type="text" class="form-control padding-override" placeholder="e.g. 200" required v-model="purchase_unit_price"
                               v-bind:class="{ 'is-invalid': attemptSubmit && missingPurchaseUnitPrice }">
                        <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'purchase_unit_price'">{{ error.text }}</div>
                    </div>

                    <label>Tax Code</label>
                    <div class="input-group">
                        <select class="custom-select mr-sm-2 padding-override" v-model="purchase_tax_code">
                            <option disabled>Select Tax Code</option>
                            <option v-for="(item, index) in tax_codes" :value="item.id" :key="index">{{ item.code }}</option>
                        </select>
                    </div>

                    <label>Description</label>
                    <div class="input-group">
                        <textarea class="form-control notes padding-override" id="" cols="30" rows="5" v-model="purchase_description">Additional notes visible to your customer</textarea>
                    </div>

                    <label>Expense Category*</label>
                    <div class="input-group">
                        <select class="custom-select mr-sm-2 padding-override" v-model="expense_category" v-bind:class="{ 'is-invalid': attemptSubmit && missingExpenseCategory }">
                            <option disabled>Select Expense Category</option>
                            <option v-for="(item, index) in expense_categories_filtered" :value="item.id" :key="index">{{ item.name }}</option>
                        </select>
                        <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'expense_category'">{{ error.text }}</div>
                    </div>
                </div>
            </form>

            <transition name="slide-fade" mode="out-in">
                <div class="error-message md-elevation-7" v-if="createItemError">
                    <span>{{ createItemError }}</span>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CreateNewItem",
        data() {
            return {
                for_sale: true,
                for_purchase: true,
                item_name: null,
                sku: null,
                sale_unit_price: null,
                sale_tax_code: null,
                sale_description: null,
                purchase_unit_price : null,
                purchase_tax_code: null,
                purchase_description: null,
                income_category: null,
                expense_category: null,
                income_categories: [],
                expense_categories: [],
                tax_codes: [],
                createItemError: '',
                track_inventory: false,
                stock_balance: null,

                //Others
                attemptSubmit: false,
                errors: [],
            }
        },
        computed: {
            missingItemName: function () {
                if (!this.item_name) { return true; } else { return false; }
            },
            missingPurchaseUnitPrice: function () {
                if (!this.purchase_unit_price) { return true; } else { return false; }
            },
            missingSaleUnitPrice: function () {
                if (!this.sale_unit_price) { return true; } else { return false; }
            },
            missingIncomeCategory: function () {
                if (!this.income_category) { return true; } else { return false; }
            },
            missingExpenseCategory: function () {
                if (!this.expense_category) { return true; } else { return false; }
            },
            requestData: function() {
                if(this.for_sale === true && this.for_purchase === false) {
                    return {
                        business_id: this.$store.state.selected_company,
                        sku: this.sku,
                        name: this.item_name,
                        track_inventory: this.track_inventory,
                        for_sale: this.for_sale,
                        for_purchase: this.for_purchase,
                        inventory_account_id: null,
                        stock_balance: this.stock_balance,
                        sale_description: this.sale_description,
                        sale_price: this.sale_unit_price,
                        sale_account_id: this.income_category,
                        sale_tax_code_id: this.sale_tax_code,
                    }
                } else if (this.for_sale === false && this.for_purchase === true) {
                    return {
                        business_id: this.$store.state.selected_company,
                        sku: this.sku,
                        name: this.item_name,
                        track_inventory: this.track_inventory,
                        for_sale: this.for_sale,
                        for_purchase: this.for_purchase,
                        inventory_account_id: null,
                        stock_balance: this.stock_balance,
                        purchase_description: this.purchase_description,
                        purchase_price: this.purchase_unit_price,
                        purchase_account_id: this.expense_category,
                        purchase_tax_code_id: this.purchase_tax_code,
                    }
                } else {
                    return {
                        business_id: this.$store.state.selected_company,
                        sku: this.sku,
                        name: this.item_name,
                        track_inventory: this.track_inventory,
                        for_sale: this.for_sale,
                        for_purchase: this.for_purchase,
                        inventory_account_id: null,
                        stock_balance: this.stock_balance,
                        purchase_description: this.purchase_description,
                        purchase_price: this.purchase_unit_price,
                        purchase_account_id: this.expense_category,
                        purchase_tax_code_id: this.purchase_tax_code,
                        sale_description: this.sale_description,
                        sale_price: this.sale_unit_price,
                        sale_account_id: this.income_category,
                        sale_tax_code_id: this.sale_tax_code,
                    }
                }
            },
            income_categories_filtered: function() {
                let items = []
                for(let i=0; i<this.income_categories.length; i++) {
                    for(let j=0; j<this.income_categories[i].items.length; j++) {
                        items.push({
                            id: this.income_categories[i].items[j].id,
                            name: this.income_categories[i].items[j].name
                        })
                    }
                }

                return items
            },

            expense_categories_filtered: function() {
                let items = []
                for(let i=0; i<this.expense_categories.length; i++) {
                    for(let j=0; j<this.expense_categories[i].items.length; j++) {
                        items.push({
                            id: this.expense_categories[i].items[j].id,
                            name: this.expense_categories[i].items[j].name
                        })
                    }
                }
                return items
            },
        },
        methods: {
            createItem() {
                this.$root.$emit('show-loading', true);
                this.axios({
                    method: 'post',
                    url: '/products',
                    data: this.requestData
                }).then(response => {
                    this.$root.$emit('show-loading', false);
                    this.$successToast('Item successfully created.')
                    this.$router.go(-1)
                }).catch(error => {
                    this.$root.$emit('show-loading', false);
                    this.$generalAPIErrorHandling(error, this.$router);
                })
            },
        },
        beforeDestroy () {
            this.$root.$off('attempt_submit_create_item')
        },
        mounted() {
            console.log("Mounted : CreateNewItem");
            let lists_requestBody = {
                "requests": [{
                    "uri": "/lists/categories",
                    "params": {
                        "company_id": this.$store.state.selected_company
                    }
                },
                    {
                        "uri": "/lists/tax_codes",
                        "params": {
                            "company_id": this.$store.state.selected_company
                        }
                    }
                ]
            };

            this.$root.$emit('show-loading', true);

            this.axios({
                method: 'post',
                url: '/lists/mixed',
                data: lists_requestBody
            }).then(response => {
                this.$root.$emit('show-loading', false);
                this.income_categories = response.data.categories;
                this.expense_categories = response.data.categories;
                this.tax_codes = response.data.tax_codes
            }).catch(error => {
                this.$root.$emit('show-loading', false);
                this.$generalAPIErrorHandling(error, this.$router);
            });

            // Will get call when user click on done button top right
            // Do checking for compulsory fields first, then pop up confirmation dialog
            this.$root.$on('attempt_submit_create_item', vars => {
                this.errors = [];
                this.attemptSubmit = true;

                if (this.missingItemName) {
                    this.errors.push({id: 'name', text: "This field is compulsory"});
                }

                if (this.for_sale) {
                    if (this.missingSaleUnitPrice) {
                        this.errors.push({id: 'sale_unit_price', text: "This field is compulsory"});
                    }

                    if (this.missingIncomeCategory) {
                        this.errors.push({id: 'income_category', text: 'This field is compulsory'});
                    }
                }

                if (this.for_purchase) {
                    if (this.missingPurchaseUnitPrice) {
                        this.errors.push({id: 'purchase_unit_price', text: "This field is compulsory"});
                    }

                    if (this.missingIncomeCategory) {
                        this.errors.push({id: 'income_category', text: 'This field is compulsory'});
                    }
                }

                if(!this.errors.length) {
                    event.preventDefault();
                    this.$confirmationToast("Create Item?", "Are you sure you want to create this item?", this.createItem, null);
                } else {
                    event.preventDefault();
                }
            })
        }
    }
</script>

<style scoped>
    .notes {
        margin-bottom: 15px;
        border-color: #05d2c5;
        border-radius: 10px;
        padding: 15px;
    }

    .switch {
        text-align: center;
    }
</style>
